import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, useResponsive } from '@garnish/core';

import { StripePaymentElement } from '@order/integrations-stripe';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassPaymentMethod = (props: Props) => {
  const { embeddedPaymentElementView, hasStripeFailedToLoad } = props;
  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      <BodyText sizeMatch={['16']} bold accessibilityRole="header" aria-level={2}>
        <FormattedMessage {...messages.title} />
      </BodyText>

      <StripePaymentElement
        show
        paymentMethods={NO_SAVED_PAYMENT_METHODS}
        embeddedPaymentElementView={embeddedPaymentElementView}
        hasStripeFailedToLoad={hasStripeFailedToLoad}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    gap: theme.spacing['4'],
  },
  containerSM: {
    gap: theme.spacing['8'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Payment method',
    description: 'Sweetpass | Checkout | Payment Method | Title',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

/**
 * Only used by the element to label saved payment methods, which it lists itself.
 */
const NO_SAVED_PAYMENT_METHODS: StripePaymentElementProps['paymentMethods'] = [];

// ─── Props ───────────────────────────────────────────────────────────────────

type StripePaymentElementProps = React.ComponentProps<typeof StripePaymentElement>;

type Props = Pick<StripePaymentElementProps, 'embeddedPaymentElementView' | 'hasStripeFailedToLoad'>; // prettier-ignore
